import Vue from 'vue'

const state = {
  baseUri: '/botw/config/user/'
}
const getters = {
}
const actions = {
  search: function (_context, [data, callback]) { // 리스트 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'search',
      params: data
    }
    console.log('actions search axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  codes: function (_context, [callback]) { // 코드 조회
    console.log('configUser-codes')
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'codes'
    }
    console.log('actions codes axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  detail: function (_context, [userSeq, callback]) { // 상세 조회
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'detail/' + userSeq
    }
    console.log('actions detail axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  spotList: function (_context, [spotSearchParam, callback]) { // 현장 조회
    console.log('spotList data: ', spotSearchParam)
    const reqData = {
      spotGubun: spotSearchParam.spotGubun,
      dongName: spotSearchParam.address,
      spotName: spotSearchParam.spotName,
      pageNum: spotSearchParam.pageNum,
      rowCount: spotSearchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'spotSearch',
      params: reqData
    }
    console.log('actions spotSearch axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  consignCompSearch: function (_context, [searchParam, callback]) { // 위탁업체 조회
    const reqData = {
      consignCompName: searchParam.consignCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.address,
      hnDuruGubun: '정보통신',
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/spot/consignCompSearch',
      params: reqData
    }
    console.log('actions consignComp/search/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  contractCompSearch: function (_context, [searchParam, callback]) { // 계약업체 목록조회
    const reqData = {
      contractCompName: searchParam.contractCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.address,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount,
      dataFlag: true
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/contractComp/search/',
      params: reqData
    }
    console.log('actions contractComp/search/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  visitCompSearch: function (_context, [searchParam, callback]) { // 방문업체 목록조회
    const reqData = {
      visitCompName: searchParam.visitCompName,
      // dongName: searchParam.address,
      extraAddress: searchParam.address,
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount,
      dataFlag: true
    }
    const axiosOption = {
      method: 'GET',
      url: '/botw/config/visitComp/search/',
      params: reqData
    }
    console.log('actions visitComp/search/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  visitCompSpotCompSearch: function (_context, [searchParam, callback]) { // 방문업체 현장 리스트 목록조회
    const reqData = {
      pageNum: searchParam.pageNum,
      rowCount: searchParam.rowCount,
      visitCompSeq: searchParam.visitCompSeq
    }
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'visitCompSpotSearch/',
      params: reqData
    }
    console.log('actions visitCompSpotSearch/ axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  insert: function (_context, [data, callback]) { // 등록
    const reqData = {
      userGroupCode: Number(data.userGroupCode),
      consignCompSeq: data.consignCompSeq === undefined ? 0 : data.consignCompSeq,
      contractCompSeq: data.contractCompSeq === undefined ? 0 : data.contractCompSeq,
      visitCompSeq: data.visitCompSeq === undefined ? 0 : data.visitCompSeq,
      userId: data.userId,
      userPassword: data.userPassword,
      userName: data.userName,
      mobileNum: data.mobileNum,
      email: data.email,
      note: data.note,
      department: data.department,
      userGubun: data.userGubun,
      userContentCodeId: data.userContentCodeId,
      detailSpotList: data.detailSpotList,
      allSpotFlag: String(data.allSpotFlag)
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'insert',
      data: reqData
    }
    console.log('actions insert axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  update: function (_context, [data, callback]) { // 수정
    const reqData = {
      userGroupCode: Number(data.userGroupCode),
      consignCompSeq: data.consignCompSeq === undefined ? '' : data.consignCompSeq,
      contractCompSeq: data.contractCompSeq === undefined ? '' : data.contractCompSeq,
      visitCompSeq: data.visitCompSeq === undefined ? '' : data.visitCompSeq,
      userId: data.userId,
      userPassword: data.userPassword,
      userSeq: data.userSeq,
      userName: data.userName,
      mobileNum: data.mobileNum,
      email: data.email,
      note: data.note,
      department: data.department,
      userGubun: data.userGubun,
      userContentCodeId: data.userContentCodeId,
      detailSpotList: data.detailSpotList,
      allSpotFlag: data.allSpotFlag === undefined ? 'false' : String(data.allSpotFlag)
      // managerYn: String(data.managerYn),
      // dataFlag: String(data.dataFlag)
    }
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'update',
      data: reqData
    }
    console.log('actions update axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  dupCheck: function (_context, [userId, callback]) { // 아이디 중복체크
    console.log('dupCheck data: ', userId)
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'dupCheck/' + userId
    }
    console.log('actions dupCheck axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  passInit: function (_context, [data, callback]) { // 비밀번호 초기화
    console.log('passInit data: ', data)
    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'passInit',
      data: data
    }
    console.log('actions passInit axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  delete: function (_context, [param, callback]) { // 미사용 처리
    const reqData = {
      userSeq: param.userSeq
    }
    console.log('delete reqData : ', reqData)

    const axiosOption = {
      method: 'POST',
      url: _context.state.baseUri + 'delete',
      data: reqData
    }
    console.log('actions delete axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  },
  refreshVisit: function (_context, [param, callback]) { // 방문업체에 매핑된 현장 정보 갱신
    const axiosOption = {
      method: 'GET',
      url: _context.state.baseUri + 'refreshVisitComp',
      params: param
    }
    console.log('actions refreshVisit axiosOption : ', axiosOption)
    Vue.axios(axiosOption).then(callback).catch(err => { console.log(err) })
  }
}
const mutations = {
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
